import React from 'react';
import { Box } from '@common-fe/common-fe';
import Lottie from 'lottie-react';

import animation from './falling-icons.json';
const BannerAnimation = () => {
  return (
    <Box
      data-testid="dashboard_banner_animation"
      overflow="hidden"
      style={{ position: 'absolute', zIndex: 1, top: 0, bottom: 0, left: 0, height: '100%' }}
    >
      <Lottie animationData={animation} loop={true} />
    </Box>
  );
};
export default BannerAnimation;
